const data=[
        {
            title:'آخر أجل لاستلام البحوث :',
            paragraph:'2025-04-16T00:00:00',
            date:"15 أبريل 2025",
            img: require('../../images/slider-background-2.webp'),
            mokupImage: require('../../images/mokup.png')
        },
        {
            title:'موعد إصدار العدد الثالث :',
            paragraph:'2025-04-25T00:00:00',
            date:"24 أبريل 2025",
            img: require('../../images/slider-background-1.webp'),
            mokupImage: require('../../images/mokup2.png')
        },
    ]

export default data